import { tv, type VariantProps } from "tailwind-variants";

export const floatingImagesVariants = tv({
  slots: {
    base: ["relative", "w-full", "h-full"],
    floatingWrapper: ["overflow-hidden z-2", "xxs:opacity-25 xs:opacity-100"],
    image: ["w-full h-auto", "select-none", "pointer-events-none object-cover"],
  },
});

export type FloatingImagesVariantProps = VariantProps<
  typeof floatingImagesVariants
>;
export type FloatingImagesReturnVariantProps = ReturnType<
  typeof floatingImagesVariants
>;
